import { render } from "./contact-card.vue?vue&type=template&id=3ef4c329"
import script from "./contact-card.vue?vue&type=script&lang=js"
export * from "./contact-card.vue?vue&type=script&lang=js"

import "./contact-card.vue?vue&type=style&index=0&id=3ef4c329&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__